import { el, setAttr } from 'redom';

import { tryFormatToBrowserFormat } from 'utilities/date';
import OutsideClickEventRegistration from 'lib/outside-click-event-registration';
import { normalizeInputType } from './utilities';

import keys from 'constants/keys';

class DateInput {

  constructor(options) {

    this.outsideEventRegistration = null;
    this.preventBlur = false;

    this.onChange = options.onChange;
    this.onClose = options.onClose;
    this.onEnterKey = options.onEnterKey;

    this.input = el('input.customers-filter-text-input-field', {
      placeholder: options.placeholder,
      value: tryFormatToBrowserFormat(options.value),
      type: normalizeInputType(options.type),
      onclick: this.focus.bind(this),
      onchange: this.handleValueChangeEvent.bind(this),
      onkeydown: this.handleInputKeyDownEvent.bind(this),
      onkeyup: this.handleInputKeyUpEvent.bind(this),
      onblur: this.handleBlurEvent.bind(this)
    });
    this.input.previousValue = '';

    this.el = el('.customers-filter-text-input-main', [this.input]);

  }

  onmount() {

    this.registerOutsideEventHandler();

  }

  onunmount() {

    this.unregisterOutsideEventHandler();

  }

  doHandleInputChange(input) {

    const previousValue = input.previousValue;
    const newValue = input.value;

    if (previousValue === newValue) {
      return;
    }

    input.previousValue = newValue;

    let date = input.valueAsDate;

    if (date === null) {
      date = new Date(newValue);
    }

    this.onChange(newValue, date);

  }

  handleValueChangeEvent(event) {

    const input = event.target;

    this.doHandleInputChange(input);

  }

  handleInputKeyDownEvent(event) {

    const key = event.key;

    if (key === keys.ENTER) {
      this.preventBlur = true;
      this.onEnterKey();
    } else if (key === keys.ESCAPE) {
      this.propogateClose();
    }

  }

  handleInputKeyUpEvent(event) {

    this.doHandleInputChange(this.input);

  }

  handleBlurEvent() {

    if (this.preventBlur === true) {
      this.preventBlur = false;
      return;
    }

    this.propogateClose();

  }

  propogateClose() {

    this.doHandleInputChange(this.input);
    this.onClose();

  }

  focus() {

    this.input.focus();
    this.input.showPicker();

  }

  setValue(value) {

    setAttr(this.input, {
      value: tryFormatToBrowserFormat(value.label)
    });

  }

  outsideClickHandler(clickTargetElement) {

    this.propogateClose();

  }

  registerOutsideEventHandler() {

    this.outsideEventRegistration = new OutsideClickEventRegistration(this.el, this.outsideClickHandler.bind(this));

  }

  unregisterOutsideEventHandler() {

    this.outsideEventRegistration.cancel();

  }

}

DateInput.types = {
  TEXT: 'text',
  NUMBER: 'number',
  DATE: 'date'
};

export default DateInput;